var render = function render(){var _vm=this,_c=_vm._self._c;return _c('AppBaseModal',_vm._g({attrs:{"title":_vm.title,"modal-width":960}},_vm.$listeners),[_c('AppScrollbarContainer',{staticClass:"disclaimer-modal"},[_c('AppLegalText',{staticClass:"text-container",attrs:{"html-content":_vm.disclaimer}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }